import { apiGet } from '@/lib/api';
import type { TournamentPlayerLeaderboardEntry } from '../interfaces/tournaments';

export const TournamentStatsService = {
  async getPlayerStats(orgId: string, tournamentId: string): Promise<TournamentPlayerLeaderboardEntry[]> {
    return apiGet<TournamentPlayerLeaderboardEntry[]>(
      `/organizations/${orgId}/tournaments/${tournamentId}/stats/players`,
    );
  },

  async getPublicPlayerStats(slugOrId: string): Promise<TournamentPlayerLeaderboardEntry[]> {
    return apiGet<TournamentPlayerLeaderboardEntry[]>(
      `/public/tournaments/${slugOrId}/stats/players`,
    );
  },
};
